import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, IconButton as BaseIconButton, useBreakpointValue, } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { STYLES } from '../internal/Button';
import { CLASS_NAMES } from '../constants';
const COMPONENT = theme.components.Button;
const DEFAULT_PROPS = COMPONENT.defaultProps;
const SIZES = COMPONENT.sizes;
const STYLES_ICON = STYLES[CLASS_NAMES.ICON];
export const IconButton = forwardRef(({ size: responsiveSize = DEFAULT_PROPS.size, ...otherProps }, ref) => {
    const size = useBreakpointValue(responsiveSize) ?? responsiveSize;
    const styles = SIZES[size];
    return (_jsx(BaseIconButton, { ref: ref, w: styles.h, h: styles.h, minW: styles.h, borderRadius: styles.borderRadius, ...otherProps, sx: {
            [`.${CLASS_NAMES.ICON}`]: {
                ...STYLES_ICON[size],
            },
            ...otherProps.sx,
        } }));
});
